import React from 'react'
import {TwIcon, TwTag, TwText} from './containers'
import {TagProps} from './types'

export const Tag = ({
  icon,
  theme = 'light',
  children,
  onClick,
  className
}: TagProps) => (
  <TwTag $theme={theme} className={className} onClick={onClick}>
    <TwIcon
      icon={icon}
      color={theme === 'light' ? 'sticker-07' : 'icon-invert'}
    />
    <TwText $theme={theme}>{children}</TwText>
  </TwTag>
)
